import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';

import EmployeeModule from './EmployeeModule';
import LogsModule from "./LogsModule";
import DeviceModule from "./DeviceModule";
import AuditTrail from './AuditTrail';
import ViewProfile from './ViewProfile';

import { MenuList, MenuItem } from 'material-ui/Menu';

import Reboot from 'material-ui/Reboot';
import 'typeface-roboto';
import Tooltip from 'material-ui/Tooltip';

import './App.css';
import TouchAppIcon from 'material-ui-icons/TouchApp';
import PeopleIcon from 'material-ui-icons/People';
import ScheduleIcon from 'material-ui-icons/Schedule';
import NotificationIcon from 'material-ui-icons/Notifications';
import LogoutIcon from 'material-ui-icons/ExitToApp'

import IconButton from 'material-ui/IconButton';
import RemoveFPIcon from 'material-ui-icons/PortableWifiOff';
import FingerprintIcon from 'material-ui-icons/Fingerprint';
import ImportIcon from 'material-ui-icons/ImportContacts';
import AuditTrailIcon from 'material-ui-icons/List';
import DetailsIcon from 'material-ui-icons/Details';
import CancelIcon from 'material-ui-icons/Cancel';
import Paper from 'material-ui/Paper';

import Table, {
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from 'material-ui/Table';

import List, {
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from 'material-ui/List';

import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Badge from 'material-ui/Badge';

import green from 'material-ui/colors/green';
import Drawer from 'material-ui/Drawer';

import DownloadIcon from 'material-ui-icons/FileDownload';
import UploadIcon from 'material-ui-icons/FileUpload';
import DeleteIcon from 'material-ui-icons/DeleteForever';

import CloseIcon from 'material-ui-icons/Close';
import RemoveIcon from 'material-ui-icons/RemoveFromQueue';


import {ajaxPost} from '../ajax';
var moment = require('moment');

const styles = theme => ({
  menu:
    {
      display: "flex",
      position: "fixed",
      margin: 0,
      marginTop:"calc(100% -89%)",
      height: "100%",
    },
  menu_divider_outer:
    {
      height: "100%",
      width: 10,
      float: "right",
      overflow: "hidden",

    },
  menu_divider_inner:
    {
      height: "100%",
      width: 2,
      boxShadow: "-2px 0px 10px gray",
      marginLeft: 10
    },
  content:
    {
      //marginLeft: 187,
      
    },
  icon:
    {
      marginRight: 0
    },
    toolbarContent:
    {
      display:"flex",
      "justify-content": "flex-end",
      flex:1,
      "flex-shrink":"1",
    },
    button: {
      '&:hover': {
        backgroundColor: green[700],
      
      },
    },
    drawerPaper:
    {
      width:400,
      padding:20,
    },
    appBar:
    {
      width: "100%",
      //width:"calc(100% - 187px)",
     // paddingLeft:187,
      background: "#fff",
      margin: 0,
     //height: "10%",
    },
    moduleContainer:
    {
      marginTop:120,
      paddingLeft: 187,
      //width: "100%",
    },
    
    page: {                 //background style
      margin: 0,
      width: "100%",
      height: "85%",
      position: "fixed",
      "z-index":"-1",
      paddingLeft: 187,
    },
    headerBorder: {     
    },
  headerLogo: {
    height: "40px",
    width: "200px",
    marginLeft: -35,
    marginTop : 10,
    
  },
  tableHeader: {
    marginLeft: 170,
    width: "calc(100% - 180px)",
    padding: 0,
  },
  moduleTitle: {
    marginTop: 10,
    color: "#2574bb",
    display: "flex",
  },
  columnHeader: {
    background: "#e1e1e1",
    color: "#000",
    width: "100%",
    height: "45px",
  }
});

global.mainApp = null;

global.updateNotifications = () =>
{
  var _this2 = global.mainApp;

  if(  _this2.state.blink == false )
  {
    _this2.setState({blink:true});
    var blinkState = true;
    var fn = () =>
    {
      if( blinkState )
        global.iconBell.style.color = "white";
      else
        global.iconBell.style.color = "transparent";

      blinkState = !blinkState;

      if( _this2.state.blink == true )
      {
          setTimeout(fn, 500);
      }
      else
      {
        global.iconBell.style.color = "white";
      }
    }
    setTimeout(fn, 500);
  }

  ajaxPost({
    url:'/DeviceCommandAPI/ListDeviceCommandGroups',
    data:global.userType=='ADMIN' ? '' : global.userName,
    startIndex:0,
    maxData:50,
    onSuccess: data =>
    {
        global.mainApp.setState({notifications:data});
    },
    finally:()=>{}
});
}

class App extends Component {
  state =
  {
    module : "Employees",
    toolbar: null,
    drawer:false,
    notifications:[],
    blink:false,
  }

  componentDidMount()
  {
     global.tblHeader = document.getElementById('tblAppbar');
     global.lblHeader = document.getElementById('lblHeaderTitle');
      this.setState({toolbar:document.getElementById('MainToolbar')});
      global.mainApp = this;
      global.iconBell = document.getElementById('iconBell');
      if( global.userType != 'USER')
        global.updateNotifications();
      this.setState({blink:false});
  }

  onMenuSelect = (name,event) =>
  {
    this.setState({module:name});
  }

  onCloseDrawer = ()=>
  {
    this.setState({drawer:false});
  }

  handleClearNotification = (notif,event) =>
  {
    ajaxPost({
      url:'/DeviceCommandAPI/ClearDeviceCommandGroup',
      data:
      {
        NotificationID:notif.NotificationID,
        CommandType:notif.CommandType
      },
      onSuccess: data => {},
      finally:()=>{}
      });
      this.setState({notifications:this.state.notifications.filter(item=>item != notif)});
  }

  handleCancelNotification = (notif,event) =>
  {
    
    ajaxPost({
      url:'/DeviceCommandAPI/CancelDeviceCommandGroup',
      data:
      {
        NotificationID:notif.NotificationID,
        CommandType:notif.CommandType
      },
      onSuccess: data => {
        var list = this.state.notifications;
        var ndx = list.indexOf(notif);
        notif.Status = 'DONE';
        var upd = JSON.parse(JSON.stringify(notif));
        if( ndx >= 0 )
            list[ndx] = upd;
    
        var elem = document.getElementById('cancel'+notif.NotificationID.toString());
        elem.style.visibility = 'visible';
      },
      finally:()=>{}
      });
      var elem = document.getElementById('cancel'+notif.NotificationID.toString());
      elem.style.visibility = 'hidden';
  }

  handleClearAllNotification = () =>
  {
    ajaxPost({
      url:'/DeviceCommandAPI/ClearAllNotifications',
      data:global.userType=='ADMIN' ? null : this.state.notifications.filter(item=>item.Status=='DONE').map(item=>item.NotificationID),
      onSuccess: data => {},
      finally:()=>{}
      });
      this.setState({notifications:[]});
  }

  getNotifyIcon = (type)=>
  {
      switch( type )
      {
        case "UPLOAD":
          return (<UploadIcon/>)
      case "DOWNLOAD":
      return (<DownloadIcon/>)
      case "REMOVE":
      return (<RemoveFPIcon/>)
      case "ENROLL":
      return (<FingerprintIcon/>)
      case "IMPORT_EMPLOYEES":
      return (<ImportIcon/>)
      case "GET_DEV_INFO":
      return (<DetailsIcon/>)
      }

      return null;
  }

  getCommandStatus = (item) =>
  {
    return item.Status != "RUNNING" ? 
        [
          <span>{item.Status}</span>,
          <span style={{"color":"red", "marginLeft":"15px", "fontSize":"9pt"}}>{item.ErrorMessage}</span>
        ]
      : 
      [
       <span>{item.Progress}</span>,
       <span style={{"marginLeft":"15px","fontSize":"8pt"}}>{moment(item.Timestamp).fromNow()}</span>
      ]
  }

  onToggleDrawer = () =>
  {
    var _this2 = this;
    var toggle = !this.state.drawer
    _this2.setState({drawer:toggle});
    _this2.setState({blink:false});

    if( toggle == true )
    {
      var fn = () =>
      {
          ajaxPost({
            url:'/DeviceCommandAPI/ListDeviceCommandGroups',
            data:global.userType=='ADMIN' ? '' : global.userName,
            startIndex:0,
            maxData:50,
            onSuccess: data =>
            {
                global.mainApp.setState({notifications:data});
                if( _this2.state.drawer )
                  setTimeout( fn, 1000);
              },
            finally:()=>{}
          })
      }
      setTimeout( fn, 1000);
    }


  }

  render() {
    const { classes } = this.props;
    var {module} = this.state;

    var listMenu = [];

    if( global.userType != "USER" )
    {
      listMenu.push({lbl:"Employees",icon:(<PeopleIcon/>)});
      listMenu.push({lbl:"Time Entries",icon:(<ScheduleIcon/>)});
    }
    else
    {
      listMenu.push({lbl:"Time Entries",icon:(<ScheduleIcon/>)});
      listMenu.push({lbl:"My Profile",icon:(<PeopleIcon/>)});
    }


    if( global.userType == "ADMIN")
    {
        listMenu.push({lbl:"Devices",icon:(<TouchAppIcon/>)});
        listMenu.push({lbl:"Audit Trail",icon:(<AuditTrailIcon/>)});
    }

    return (
      <div >
        <Reboot />
        <img src='bg.png' className={classes.page} />
        <AppBar position="fixed" className={classes.appBar}>
        
            <Toolbar>
            <img src='header.png' className={classes.headerLogo} />
            <div id='lblHeaderTitle' className={classes.moduleTitle}></div>
             <div className={classes.toolbarContent} id='MainToolbar'>
             
              </div>
              <Tooltip id="tooltip-logout"  title="Logout">
              <IconButton onClick={()=>window.location = "Logout"} color="inherit" className={classes.button} style={{"color":"#606060"}}>
                <LogoutIcon/>
              </IconButton>
              </Tooltip>
              {global.userType != "USER" &&
              <IconButton color="inherit" id="iconBell"
              onClick={this.onToggleDrawer.bind(this)} 
              style={{"color":"#606060"}}>
              <Badge className={classes.margin} badgeContent={this.state.notifications.length} color="black" style={{"color":"#606060"}}>
                  <NotificationIcon />
              </Badge>
              </IconButton>
              }
            </Toolbar>
              <div className={classes.columnHeader}>
            <Toolbar>
              <Table height="45px" id='tblAppbar' className={classes.tableHeader}>
              </Table>
              </Toolbar>
           </div>
             </AppBar>
         
        <div className={classes.content} >
        <div className={classes.menu}>
          <MenuList>{
            listMenu.map( item=> 
            (
            <MenuItem selected={item.lbl == module} onClick={this.onMenuSelect.bind(this,item.lbl)} >
              <ListItemIcon className={classes.icon}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.lbl} />
            </MenuItem>
            ))
          }
          </MenuList>
          <div className={classes.menu_divider_outer}>
            <div className={classes.menu_divider_inner}>
            </div>
          </div>
        </div >
       
    <Paper style={{"width":"100%"}} ></Paper>
         
        <div className={classes.moduleContainer} >
          { module == 'Employees' && <EmployeeModule toolbar={this.state.toolbar} />}
          { module == 'My Profile' && <ViewProfile toolbar={this.state.toolbar} />}
          { module == 'Time Entries' && <LogsModule toolbar={this.state.toolbar} />}
          { module == 'Devices' && <DeviceModule toolbar={this.state.toolbar} />}
          { module == 'Audit Trail' && <AuditTrail toolbar={this.state.toolbar} />}
          </div>

          </div >
       <Drawer variant="temporary" anchor="right"
          classes={{
            paper: classes.drawerPaper,
          }}
          open={this.state.drawer}
          onClose={this.onCloseDrawer.bind(this)}>
          <div>
            
          <List component="nav">
          <ListItem>
            <Button color="primary" onClick={this.handleClearAllNotification}>Clear All</Button>
            <ListItemSecondaryAction>
                  <IconButton aria-label="Close" onClick={()=>{this.setState({drawer:false})}}>
                      <CloseIcon />
                  </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
            {this.state.notifications.map(item=>(
            <ListItem button>
              <ListItemIcon>
                {
                  this.getNotifyIcon(item.CommandType)
                }
              </ListItemIcon>
            <ListItemText inset primary={item.Caption} 
            secondary={this.getCommandStatus(item)} 
            />
           <ListItemSecondaryAction>
             {item.Status == 'RUNNING' ?
                <IconButton aria-label="Cancel" id={'cancel'+item.NotificationID.toString()} onClick={this.handleCancelNotification.bind(this,item)}>
                <CancelIcon />
              </IconButton>
            :
                <IconButton aria-label="Delete" onClick={this.handleClearNotification.bind(this,item)}>
                    <RemoveIcon />
                </IconButton>
             }
            </ListItemSecondaryAction>
            </ListItem>
          ))
          }
          {this.state.notifications.length == 0 && <ListItem><ListItemText primary="No notification"/></ListItem>}
          </List>
          </div>
        </Drawer>

      </div>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/admin/App.js